import { Users, ShieldCheck, Microscope, LayoutGrid, HeartPulse, NotebookPen, Trophy } from "lucide-react";

const MAIN = [{ key: "clients", label: "People", Icon: Users }, { key: "review", label: "AI Review", Icon: ShieldCheck }, { key: "insights", label: "Insights", Icon: Microscope }, { key: "community", label: "Community", Icon: Trophy }];
const DETAIL = [{ key: "habits", label: "Habits", Icon: LayoutGrid }, { key: "wellbeing", label: "Wellbeing", Icon: HeartPulse }, { key: "notes", label: "Notes & AI", Icon: NotebookPen }];

function Bar({ items, value, onChange, badges = {}, prefix, size }) {
  return (
    <div className={`flex gap-1 rounded-full bg-stone-900/5 p-1 ${size}`} role="tablist" data-testid={`${prefix}-tabs`}>
      {items.map(({ key, label, Icon }) => (
        <button key={key} role="tab" aria-selected={value === key} onClick={() => onChange(key)} data-testid={`${prefix}-${key}`}
          className={`flex-1 inline-flex items-center justify-center gap-1.5 text-sm font-semibold px-3 py-2 rounded-full transition ${value === key ? "bg-stone-900 text-white shadow" : "text-stone-600 hover:text-stone-900"}`}>
          <Icon className="w-4 h-4" /> <span className="hidden sm:inline">{label}</span>
          {badges[key] > 0 && <span className={`text-[10px] font-mono px-1.5 rounded-full ${value === key ? "bg-amber-400 text-stone-900" : "bg-amber-200 text-amber-900"}`} data-testid={`${prefix}-badge-${key}`}>{badges[key]}</span>}
        </button>
      ))}
    </div>
  );
}

export function ClinicianTabs({ value, onChange, reviewCount }) {
  return <nav className="sticky top-[64px] z-30 -mx-4 px-4 py-2 bg-paper/90 backdrop-blur"><Bar items={MAIN} value={value} onChange={onChange} badges={{ review: reviewCount }} prefix="ctab" size="max-w-lg" /></nav>;
}

export function DetailTabs({ value, onChange }) {
  return <Bar items={DETAIL} value={value} onChange={onChange} prefix="dtab" size="max-w-sm" />;
}
